import "./styles.scss";
import { Fragment, useEffect } from "@wordpress/element";
import { select, dispatch } from '@wordpress/data';
import { THEME_VARIABLES_MAP } from "~buildable/utils/constants";
import {getHslFromHex} from "~buildable/utils/helpers";

let activeInnerBlockIndex = 0;

const ActiveInnerBlockControls = props => {
  console.log("highlight-box-group edit", props);
  const { clientId, setAttributes, content } = props;

  const {
    innerCount,
    activeInnerBlockId,
    accentColor
  } = props.attributes;

  const innerBlocks = select("core/editor").getBlocksByClientId(clientId)[0].innerBlocks;

  const newInnerCount = innerBlocks.length;

  let currentActiveInnerBlockId = undefined;
  innerBlocks.forEach((block, index) => {
    if (block.attributes.isActive) {
      currentActiveInnerBlockId = block.attributes.initialClientId;
    }

    const updatedBlockAttributes = { index };

    dispatch("core/editor").updateBlockAttributes(block.clientId, updatedBlockAttributes);
  });

  const setActiveInnerBlock = id => {
    setAttributes({ activeInnerBlockId: id });

    innerBlocks.forEach((block, index) => {
      if (block.attributes.initialClientId === id) {
        activeInnerBlockIndex = index;
        setAttributes({ activeInnerBlockIndex });
      }

      dispatch("core/editor").updateBlockAttributes(
        block.clientId,
        { isActive: block.attributes.initialClientId === id }
      );
    });
  }

  const setActiveInnerBlockByIndex = index => {
    activeInnerBlockIndex = index;
    setAttributes({ activeInnerBlockIndex });

    innerBlocks.forEach((block, i) => {
      if (i === index && block.attributes.initialClientId) {
        setAttributes({ activeInnerBlockId: block.attributes.initialClientId  });
      }

      dispatch("core/editor").updateBlockAttributes(
        block.clientId,
        { isActive: i === index && typeof block.attributes.initialClientId !== "undefined" }
      );
    })
  }

  useEffect(() => {
    if (innerCount !== newInnerCount || (newInnerCount && !activeInnerBlockId)) {
      if (innerCount !== newInnerCount) {
        setAttributes({ innerCount: newInnerCount });
      }

      setActiveInnerBlockByIndex(newInnerCount - 1);
    } else if (activeInnerBlockId && currentActiveInnerBlockId !== activeInnerBlockId) {
      setActiveInnerBlock(activeInnerBlockId);
    }
  })

  const accentColorHex = THEME_VARIABLES_MAP[accentColor];
  const iconStyle = { color: accentColorHex };

  const accentColorHsl = getHslFromHex(accentColorHex);
  iconStyle.backgroundColor = accentColorHsl.l < 50 ? "white" : "black";

  return (
    <Fragment>
      { (newInnerCount > 0 && activeInnerBlockIndex !== 0) && (
        <div
          className="active-inner-block-control icon-container back"
          onClick={ () => setActiveInnerBlockByIndex(activeInnerBlockIndex - 1) }
          style={ iconStyle }
        >
          <i className="far fa-angle-left" />
        </div>
      ) }
      { content }
      { (newInnerCount > 0 && activeInnerBlockIndex !== newInnerCount - 1) && (
        <div
          className="active-inner-block-control icon-container forward"
          onClick={ () => setActiveInnerBlockByIndex(activeInnerBlockIndex + 1) }
          style={ iconStyle }
        >
          <i className="far fa-angle-right" />
        </div>
      ) }
    </Fragment>
  );
}

export default ActiveInnerBlockControls;
